import domToImage from "dom-to-image-more";

import { useToastsStore } from "@/stores/toasts";

export function useClipboard() {
  const toasts = useToastsStore();

  /**
   * Render the given element in a backbuffer, encode it as PNG and write the result to the clipboard.
   * @param element the dom element to copy
   * @param scale the scale factor for the image (default: 2)
   */
  async function copyElementAsPng(element: HTMLElement, scale = 2) {
    const png = await domToImage.toBlob(element, {
      scale,
      filter: (node: Element) => {
        const exclusionClasses = ["remove-from-capture"];
        return !exclusionClasses.some((classname) => node.classList?.contains(classname));
      },
    });
    if (png) {
      try {
        await navigator.clipboard.write([
          new ClipboardItem({
            "image/png": png,
          }),
        ]);
        toasts.addToast("Copied !", "success", { duration: 5 });
      } catch {
        toasts.addToast("Skore HUB is not allowed to write to the clipboard.", "error", {
          duration: 5,
        });
      }
    }
  }

  /**
   * Copy a string to the clipboard.
   * @param text the text to copy
   */
  async function copyText(text: string, successMessage: string = "Copied !") {
    try {
      await navigator.clipboard.writeText(text);
      toasts.addToast(successMessage, "success", { duration: 5 });
    } catch {
      toasts.addToast("Skore HUB is not allowed to write to the clipboard.", "error", {
        duration: 5,
      });
    }
  }

  return {
    copyElementAsPng,
    copyText,
  };
}
